import { render, staticRenderFns } from "./op-detail.vue?vue&type=template&id=31577ad2&scoped=true"
import script from "./op-detail.vue?vue&type=script&lang=js"
export * from "./op-detail.vue?vue&type=script&lang=js"
import style0 from "./op-detail.vue?vue&type=style&index=0&id=31577ad2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31577ad2",
  null
  
)

export default component.exports